import axios from "axios";
import { EXTERNAL_API_URL } from "../index";

export const GET_REPORT_URL = "Reports/GetReport";

export function getReport(data) {
  return axios.post(EXTERNAL_API_URL + GET_REPORT_URL, data, { responseType: "blob" });
}